import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync } from '../../core/ComponentSync.js';
import { ModuleFE_Dialog } from '../../component-modules/ModuleFE_Dialog.js';
import { LL_H_C, LL_V_L } from '../../components/Layouts/index.js';
import { TS_Icons } from '@nu-art/ts-styles';
import { TS_Checkbox } from '../../components/TS_Checkbox/TS_Checkbox.js';
import { Button } from '../../components/Button/Button.js';
import { QueueV2 } from '@nu-art/ts-common/utils/queue-v2';
import { ModuleFE_SyncEnvV2 } from '../../modules/sync-env/ModuleFE_SyncEnvV2.js';
import './Dialog_SyncEnvFromProd.scss';
const Const_SyncEnv_ModalParallel = 2;
export class Dialog_SyncEnvFromProd extends ComponentSync {
    static show = () => {
        ModuleFE_Dialog.show({
            content: _jsx(Dialog_SyncEnvFromProd, {}),
        });
    };
    deriveStateFromProps(nextProps, state) {
        state.running ??= false;
        return state;
    }
    async componentDidMount() {
        try {
            const collections = await ModuleFE_SyncEnvV2.fetchSyncableCollections();
            this.setState({
                collections: collections.map(dbKey => ({ dbKey, wipe: false, status: 'idle' })),
            });
        }
        catch (e) {
            this.setState({ error: e.message });
        }
    }
    patchRow = (dbKey, patch) => {
        this.setState(prev => ({
            collections: prev.collections?.map(row => row.dbKey === dbKey ? { ...row, ...patch } : row),
        }));
    };
    syncCollections = async (dbKeys) => {
        if (this.state.running || !this.state.collections)
            return;
        this.setState({ running: true });
        const queue = new QueueV2('sync-from-prod', async (dbKey) => {
            this.patchRow(dbKey, { status: 'running', error: undefined });
            const row = this.state.collections.find(collection => collection.dbKey === dbKey);
            await ModuleFE_SyncEnvV2.syncFromProd({
                selectedModules: [dbKey],
                deleteMissing: true,
                cleanSync: row?.wipe,
            });
        }).setParallelCount(Const_SyncEnv_ModalParallel);
        for (const dbKey of dbKeys)
            queue.addItemImpl(dbKey, () => this.patchRow(dbKey, { status: 'done' }), error => this.patchRow(dbKey, { status: 'failed', error: error.message }));
        await queue.executeSync();
        this.setState({ running: false });
    };
    render() {
        return _jsxs(LL_V_L, { id: 'dialog__sync-env-from-prod', children: [this.renderHeader(), this.renderBody(), this.renderFooter()] });
    }
    renderHeader = () => {
        return _jsxs(LL_H_C, { className: 'dialog__sync-env-from-prod__header', children: [_jsx("div", { className: 'dialog__sync-env-from-prod__header__title', children: "Sync DB from Prod" }), _jsx(TS_Icons.x.component, { onClick: () => ModuleFE_Dialog.close() })] });
    };
    renderBody = () => {
        if (this.state.error)
            return _jsx("div", { className: 'dialog__sync-env-from-prod__error', children: this.state.error });
        if (!this.state.collections)
            return _jsx("div", { className: 'dialog__sync-env-from-prod__loading', children: "Loading collections\u2026" });
        return _jsx(LL_V_L, { className: 'dialog__sync-env-from-prod__list', children: this.state.collections.map(row => this.renderRow(row)) });
    };
    renderRow = (row) => {
        return _jsxs(LL_H_C, { className: 'dialog__sync-env-from-prod__row', children: [_jsx("div", { className: 'dialog__sync-env-from-prod__row__name', children: row.dbKey }), _jsx(TS_Checkbox, { disabled: this.state.running, checked: row.wipe, onCheck: wipe => this.patchRow(row.dbKey, { wipe }), children: "Wipe" }), _jsx("div", { className: `dialog__sync-env-from-prod__row__status status-${row.status}`, children: row.error ?? row.status }), _jsx(Button, { variant: 'secondary', disabled: this.state.running, onClick: () => this.syncCollections([row.dbKey]), children: "Sync" })] }, row.dbKey);
    };
    renderFooter = () => {
        const collections = this.state.collections;
        if (!collections?.length)
            return;
        return _jsx(LL_H_C, { className: 'dialog__sync-env-from-prod__footer', children: _jsx(Button, { variant: 'primary', disabled: this.state.running, onClick: () => this.syncCollections(collections.map(row => row.dbKey)), children: "Sync All" }) });
    };
}
//# sourceMappingURL=Dialog_SyncEnvFromProd.js.map